import axios from 'axios';

const API = axios.create({ baseURL: 'https://kami-production-02dd.up.railway.app/api' });

API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = token;
  return req;
});

export const signUp = (formData) => API.post('/auth/signup', formData);
export const login = (formData) => API.post('/auth/login', formData);
export const getUsers = () => API.get('/users');
export const updateProfile = (formData) => API.put('/users/profile', formData);
export const createMatch = (matchedUserId) => API.post('/matches', { matchedUserId });
export const getMatches = () => API.get('/matches');
export const getProfile = () => API.get('/users/profile');
export const sendMessage = (receiverId, content) => API.post('/messages', { receiverId, content });
export const getMessages = (receiverId) => API.get(`/messages/${receiverId}`);
export const uploadPhoto = (formData) => API.post('/upload', formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Authorization': localStorage.getItem('token')
  }
});